import Icon from '../components/Icon.vue'

Icon.register({"square":{"width":1536,"height":1792,"paths":[{"d":"M1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/square.js
// module id = 1739
// module chunks = 0